export default {
//   getCompany(state) {
//     return state.company;
//   },
 getCompanyProfile(state){
     return state.companyProfile;
 },

 getCandidatesForComp(state){
    return state.candidatesComp;
 },
 getCandidatesJobList(state){
    return state.candidatesJobList
    ;
 },
 getAllCompanyInsights(state) {
   return state.companyInsights;
 },
 getjobCandidatesLists(state) {
   return state.jobCandidatesLists
 }
};
